@if (client._id) {
  <div class="modal fade" id="add-goal-modal" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add goal</h5>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form #addGoalForm="ngForm">
            <div class="form-group">
              <label>Goal <span class="text-danger small">(required)</span></label>
              <input type="text" class="form-control" name="description" [(ngModel)]="newGoal.description" placeholder="Goal description" required>
            </div>
            <div class="form-group">
              <label>Due date <span class="text-danger small">(required)</span></label>
              <input type="date" class="form-control" name="dueDate" [(ngModel)]="newGoal.dueDate" [pattern]="dateRegexp" placeholder="YYYY-MM-DD" required>
            </div>
            <div class="form-group">
              <label>Achieved <span class="text-danger small">(required)</span></label>
              <select class="form-control" name="achieved" [(ngModel)]="newGoal.achieved" required>
                <option value="" selected disabled>Select achieved</option>
                <option [value]="true">Yes</option>
                <option [value]="false">No</option>
              </select>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
            [disabled]="!addGoalForm.form.valid"
            (click)="addArrayField()">
            <i class="fa fa-plus-circle"></i> Add goal
          </button>
        </div>
      </div>
    </div>
  </div>
}